import likedUsersState from "./liked-users/state"

export default {
	creatingPost: false,
	currentPost: {},
	currentPostLoading: false,
	postListOffset: 0,
	postListLimit: 10,
	postListFetchCompleted: false,
	postListLoading: false,
	posts: [],
	attachmentsLoading: false,
	attachmentLoading: false,
	attachmentsOffset: 0,
	attachmentsLimit: 6,
	attachmentsFullyLoaded: false,
	...likedUsersState
}